import * as React from 'react';
import * as styles from './styles.css';
import { Suggest } from './components';
import { ILocation } from '../../types/location';
import { IconSearch16, InputAdornment } from '@cian/ui-kit';
import { FormInputsLayout } from '../FormInputsLayout';

export interface ILocationSuggestProps {
  inputValue: string;
  suggest: ILocation[];
  isSuggestShown: boolean;
  placeholder: string;
  isLoading: boolean;
  inputName: string;
  suggestRef: React.LegacyRef<HTMLDivElement>;

  onChange(value: string): void;

  onItemClick(value: ILocation): void;
}

export const LocationSuggest: React.FC<React.PropsWithChildren<ILocationSuggestProps>> = ({
  onChange,
  inputValue,
  suggest,
  onItemClick,
  isSuggestShown,
  placeholder,
  isLoading,
  inputName,
  suggestRef,
}) => {
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value),
    [onChange],
  );

  return (
    <div className={styles['container']} data-testid="location-suggest">
      <div className={styles['input-container']}>
        <FormInputsLayout
          InputProps={{
            loading: isLoading,
            placeholder,
            value: inputValue,
            onChange: handleChange,
            leftAdornment: (
              <InputAdornment>
                <IconSearch16 color="black_100" />
              </InputAdornment>
            ),
            name: inputName,
          }}
          fullwidth
        />
      </div>
      {isSuggestShown && <Suggest suggest={suggest} suggestRef={suggestRef} onItemClick={onItemClick} />}
    </div>
  );
};

LocationSuggest.displayName = 'LocationSuggest';
